import 'react';
import classnames from 'classnames';
import styled, { css } from 'styled-components';
import { selectFromTheme } from '@thisisbud/sc-utils';
import { jsx } from 'react/jsx-runtime';

let _ = t => t,
  _t,
  _t2;
const dividerClassName = 'bui-divider';
const dividerCss = /*#__PURE__*/css(_t || (_t = _`
  display: block;
  margin: 0;
  border: 0;
  background-color: ${0};
  height: ${0};
`), selectFromTheme('colorDivider'), function (props) {
  const {
    $strong,
    theme
  } = props;
  if ($strong === true) {
    return theme.thicknessDividerStrongDefault; // eslint-disable-line @typescript-eslint/no-unsafe-member-access
  }

  return theme.thicknessDividerDefault; // eslint-disable-line @typescript-eslint/no-unsafe-member-access
});

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledHr = /*#__PURE__*/styled.hr.withConfig({
  displayName: "StyledHr",
  componentId: "sc-cn6kjp-0"
})(_t2 || (_t2 = _`
  ${0}
`), dividerCss);

/**
 * Renders a horizontal rule to create a thematic break between content.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { Divider } from '@thisisbud/bui-react-divider'
 *
 * function Example() {
 *   return <Divider/>
 * }
 * ```
 */
function Divider(props) {
  const {
    as,
    className,
    strong
  } = props;
  return /*#__PURE__*/jsx(StyledHr, {
    $strong: strong,
    as: as,
    className: classnames(dividerClassName, className)
  });
}
Divider.displayName = 'Divider';

export { Divider, dividerClassName, dividerCss };
